var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { xs: _vm.xs, md: _vm.md, "no-margin": "" } },
    [
      _c(
        "w-row",
        { attrs: { "no-margin": "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("w-input-number", {
                attrs: {
                  fancy: "",
                  value: _vm.date,
                  min: 1,
                  max: 31,
                  decimals: 0,
                  "calculate-decimals": 0,
                  label: _vm.$ct("date"),
                },
                on: {
                  input: function ($event) {
                    return _vm.setDate($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("app-month-select", {
                attrs: {
                  fancy: "",
                  label: _vm.$ct("month"),
                  value: _vm.month,
                  "use-go-time": "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setMonth($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }